import * as React from "react";

import Link, { LinkedComponent } from "valuelink"
// Typescript import
import { Input, NumberInput, TextArea, Select, Radio, Checkbox } from 'valuelink/lib/tags'

export function precisionRound(number : number, precision: number) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
}

export interface CalculatorProps {
    name: string;
    rarity: string;
    level: number;
    type: string;
}

interface STRCalcState {
    STR : number;
    addSTR : number;
}


export class STRCalculator extends LinkedComponent<{}, any> {
    constructor(props : any){
        super(props);
        this.state = {
            STR : 250,
            addSTR : 250
        }
    }
    render() {
        const linked = this.linkAll();
        return <div>
            With <NumberInput className="statInput sentence" type="number" valueLink={linked.STR} /> STR, your multiplier is <b>{precisionRound((1+this.state.STR/250), 2)}x</b>.<br/>
            Another <NumberInput className="statInput sentence" type="number" valueLink={linked.addSTR} /> STR will increase your multiplier to <b>{precisionRound((1+(this.state.STR+this.state.addSTR)/250), 3)}x</b>, an overall <b>{precisionRound((1+(this.state.STR+this.state.addSTR)/250)/(1+this.state.STR/250)*100 - 100, 3)}%</b> increase in damage.
        </div>;
    }
}



export class INTCalculator extends LinkedComponent<{}, any> {
    constructor(props : any){
        super(props);
        this.state = {
            INT : 250,
            addINT : 250
        }
    }
    render() {
        const linked = this.linkAll();
        return <div>
            With <NumberInput className="statInput sentence" type="number" valueLink={linked.INT} /> INT, your multiplier is <b>{precisionRound((1+this.state.INT/250), 2)}x</b>.<br/>
            Another <NumberInput className="statInput sentence" type="number" valueLink={linked.addINT} /> INT will increase your multiplier to <b>{precisionRound((1+(this.state.INT+this.state.addINT)/250), 3)}x</b>, an overall <b>{precisionRound((1+(this.state.INT+this.state.addINT)/250)/(1+this.state.INT/250)*100 - 100, 3)}%</b> increase in damage.
        </div>;
    }
}
